module.exports = __webpack_public_path__ + "media/images/icons/twotone/contacts-fa4f4725abdf314e1110ee4aa381abe5.svg";